import React, { useContext, useEffect, useState } from "react";
import {
  Routes,
  Route,
  BrowserRouter,
  Navigate,
  useLocation,
} from "react-router-dom";
import Home from "../pages/Home.jsx";
import About from "../pages/About.jsx";
import ScemeDetail from "../pages/ScemeDetail.jsx";
import Sceme from "../pages/Sceme.jsx";
import ProductList from "../pages/Product/ProductList.jsx";
import ProductDetails from "../pages/Product/ProductDetails.jsx";
import ContactUs from "../pages/ContactUs.jsx";
import MyAccount from "../pages/MyAccount.jsx";
import Mainroutes from "./Mainroutes.jsx";
import MyDashboard from "../dashboard/MyDashboard.jsx";
import Profile from "../dashboard/Profile.jsx";
import Kyc from "../dashboard/Kyc.jsx";
import DigitalGold from "../dashboard/DigitalGoldSchemes.jsx";
import Notifycation from "../dashboard/Notifycation.jsx";
import Myorder from "../dashboard/Myorder.jsx";
import MyBankAccount from "../dashboard/MyBankAccount.jsx";
import { Faqpage } from "../pages/Faqpage.jsx";
import { Logindetail } from "../context/Logindetail.js";
import { PagesApi } from "../api/Pageapi.js";
import ChitSchemes from "../dashboard/ChitSchemes.jsx";
import Beneficiaries from "../dashboard/Beneficiaries.jsx";
import { Footerslug } from "../pages/Footerslug.jsx";
import { getSettingApi } from "../api/Controllapi.js";
import GoldPlantsSchems from "../dashboard/GoldPlantsSchems.jsx";
import { Footerpages } from "../context/Footerpages.js";
import Commission from "../dashboard/Commission.jsx";
import PayoutRequest from "../dashboard/PayoutRequest.jsx";
import CartPage from "../pages/CartPage.jsx";
import CheckOutFormPage from "../pages/CheckOutFormPage.jsx";
import AddressForm from "../pages/Product/AddressForm.jsx";
import OrderDetailPage from "../dashboard/OrderDetailPage.jsx";
import AddressFormProfileEdit from "../pages/Product/AddressFormProfileEdit.jsx";
import instance from "../Config/Config.js";
//added
import CareerPage from "../pages/Career.jsx";
import DigitalSilverScheme from "../dashboard/DigitalSilverSchemes.jsx";
// import { MyVouchers } from "../dashboard/MyVouchers.jsx";
import MyVouchers from "../dashboard/MyVouchers.jsx";
import Encashment from "../dashboard/encashment/Encashment.jsx";
import WalletHistory from "../dashboard/WalletHistory.jsx";
import Wishlist from "../dashboard/Wishlist.jsx";
import MyFranchise from "../dashboard/MyFranchise.jsx";
import ManufacturerDesigns from "../dashboard/ManufacturerDesigns.jsx";
import SubmitPaymentProof from "../dashboard/SubmitPaymentProof.jsx";

import FindFranchise from "../pages/FindFranchise.jsx";


const ScrollToTop = () => {
  // Extracts pathname property(key) from an object
  const { pathname } = useLocation();

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    window.scrollTo(0, 0);
    window.history.scrollRestoration = "manual";
  }, [pathname]);
};

const Approutes = () => {
  const { token, detail_info } = useContext(Logindetail);
  const { setfooterpage } = useContext(Footerpages);
  const [setting_data, setsetting_data] = useState([]);
  const [footer_pages, setfooter_pages] = useState([]);
  const [openSchemes, setopenSchemes] = useState(false);
  const [Isloading, setIsloading] = useState(true);
  // const [loginRole,setLoginRole] = useState()

  const setting_fun = () => {
    getSettingApi()
      .then((res) => {
        setsetting_data(res?.data);
        setIsloading(false);
      })
      .catch((err) => {
        setIsloading(true);
      });
  };

  const settingpages = () => {
    PagesApi()
      .then((res) => {
        setfooter_pages(res?.data);
        setIsloading(false);
        setfooterpage(res?.data);
      })
      .catch((err) => {
        setIsloading(true);
      });
  };

  useEffect(() => {
    setting_fun();
    settingpages();
  }, []);



  const [images, setImages] = useState(null)

  // console.log("images", images)

  const GetCheckoutList = async () => {
    try {
      const responseApi = await instance.get(`page_banner`);
      setImages(responseApi?.data)

    } catch (error) {
      console.error(
        "Error fetching cart:",
        error.response?.data || error.message
      );

    }
  };

  useEffect(() => {
    GetCheckoutList();
  }, []);








  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        {token && detail_info ? (
          <Route
            element={
              <Mainroutes
                openSchemes={openSchemes}
                setopenSchemes={setopenSchemes}
                setting_data={setting_data}
                footerpages={footer_pages}
              // setLoginRole={setLoginRole}
              />
            }
          >
            <Route
              path="/user/dashboard"
              element={<MyDashboard settings={setting_data} image={images?.dashborad_image} />}
            />
            {/* <Route path="/user/transaction" element={<Transaction />} /> */}
            <Route
              path="/user/chit-jewels"
              element={<ChitSchemes settings={setting_data} />}
            />
            <Route
              path="/user/digital-gold"
              element={<DigitalGold settings={setting_data} />}
            />
            <Route
              path="/user/digital-silver"
              element={<DigitalSilverScheme settings={setting_data} />}
            />
            <Route
              path="/user/gold-plant"
              element={<GoldPlantsSchems settings={setting_data} />}
            />
            <Route
              path="/user/submit-payment-proof"
              element={<SubmitPaymentProof settings={setting_data} image={images?.dashborad_image} />}
            />
            <Route
              path="/user/beneficiaries"
              element={<Beneficiaries settings={setting_data} />}
            />
            <Route path="/user/kyc" element={<Kyc settings={setting_data} />} />
            <Route
              path="/user/myprofile"
              element={<Profile settings={setting_data} />}
            />
            <Route
              path="/user/companyprofile"
              element={<Profile settings={setting_data} />}
            />
            <Route
              path="/user/Notifycation"
              element={<Notifycation settings={setting_data} />}
            />
            <Route
              path="/user/mybank-account"
              element={<MyBankAccount settings={setting_data} />}
            />
            <Route
              path="/user/myorders"
              element={<Myorder settings={setting_data} />}
            />
            <Route
              path="/user/myordersagent"
              element={<Myorder settings={setting_data} />}
            />
            <Route
              path="/user/my-vouchers"
              element={<MyVouchers settings={setting_data} />}
            />

            <Route
              path="/user/encashment"
              element={<Encashment settings={setting_data} />}
            />
            <Route
              path="/user/commission"
              element={<Commission settings={setting_data} />}
            />
            <Route
              path="/user/my-franchise"
              element={<MyFranchise settings={setting_data} />}
            />
            <Route
              path="/user/payoutrequest"
              element={<PayoutRequest settings={setting_data} />}
            />
            <Route
              path="/user/wallet-history"
              element={<WalletHistory settings={setting_data} />}
            />
            <Route
              path="/user/manufacturer-designs"
              element={<ManufacturerDesigns settings={setting_data} />}
            />
            <Route path="/user/account-setup" element={<MyAccount />} />

            <Route path="/user/pages/:slug" element={<Footerslug />} />
            {/* new added .... */}

            <Route
              path="/checkout"
              element={<CheckOutFormPage setting_data={setting_data} />}
            />
            <Route
              path="/FillForm"
              element={<AddressForm setting_data={setting_data} />}
            />
            <Route
              path="/editFillForm/:id"
              element={<AddressFormProfileEdit setting_data={setting_data} />}
            />
            <Route
              path="/orderdetails/:id"
              element={<OrderDetailPage setting_data={setting_data} />}
            />
            {/* new added .... */}
          </Route>
        ) : (
          <>
            <Route path="/user/*" element={<Navigate to="/" />} />
            <Route path="/user" element={<Navigate to="/" />} />
          </>
        )}

        <Route
          element={
            <Mainroutes
              openSchemes={openSchemes}
              setting_data={setting_data}
              footerpages={footer_pages}
            />
          }
        >
          <Route
            path="/"
            element={
              <Home
                setopenScheme={setopenSchemes}
                setting_datas={setting_data}
              />
            }
          />
          <Route
            path="/about"
            element={<About setting_datas={setting_data} image={images?.about_us} />}
          />
          {/* Added */}
          <Route
            path="/career"
            element={<CareerPage />}
          />
          <Route
            path="/scheme-detail/:slug"
            element={<ScemeDetail setopenSchemes={setopenSchemes} setting_datas={setting_data} />}
          />
          <Route
            path="/scheme"
            element={
              <Sceme
                setopenScheme={setopenSchemes}
                setting_datas={setting_data}
              />
            }
          />
          <Route path="/gold-silver" element={<ProductList image={images?.product_image} />} />
          <Route path="/gold" element={<ProductList image={images?.product_image} />} />
          <Route path="/silver" element={<ProductList image={images?.product_image} />} />

          <Route path="/detail/:id" element={<ProductDetails />} />
          <Route
            path="/contact"
            element={<ContactUs setting_data={setting_data} image={images?.contact_image} />}
          />

          <Route
            path="/Faq"
            element={<Faqpage setting_datas={setting_data} />}
          />
          <Route path="/cart" element={<CartPage image={images?.cart_image} />} />
          <Route
            path="/user/wishlist"
            element={<Wishlist settings={setting_data} />}
          />
          <Route path="/pages/:slug" element={<Footerslug image={images} />} />
          <Route path="/franchise" element={<FindFranchise />} />
          <Route
            path="*"
            element={
              <div className="text-center">
                <img src="/assets/images/404img.png" />
              </div>
            }
          />{" "}
          {/* Fallback for undefined routes */}
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Approutes;
